import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-R99FYT0RHV';

function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // If gtag is available, send a pageview for SPA route changes
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search]);

  return null;
}

export default GoogleAnalytics;

